// Centralized error handling, humanization and lightweight logging.

export function logError(scope, error) {
  // Single funnel for logging; swap for a real logger/Sentry later.
  // eslint-disable-next-line no-console
  console.error(`[ABAY360:${scope}]`, error?.message || error, error);
}

const FRIENDLY = [
  { match: /not configured/i, msg: "The backend isn't connected yet. Add your Supabase keys to continue." },
  { match: /Invalid login credentials/i, msg: "Incorrect email or password." },
  { match: /Email not confirmed/i, msg: "Please verify your email before logging in." },
  { match: /User already registered/i, msg: "An account with this email already exists." },
  { match: /Password should be at least/i, msg: "Password must be at least 6 characters." },
  { match: /rate limit/i, msg: "Too many attempts. Please try again in a moment." },
  { match: /Failed to fetch|NetworkError/i, msg: "Network error. Check your connection and try again." },
  { match: /new row violates row-level security|permission denied|row-level security/i, msg: "You don't have permission to do that." },
];

export function humanizeError(error) {
  const message = typeof error === "string" ? error : error?.message || "Something went wrong.";
  for (const rule of FRIENDLY) {
    if (rule.match.test(message)) return rule.msg;
  }
  return message;
}

/** Wrap an async service call: logs + rethrows a humanized Error. */
export async function guard(scope, fn) {
  try {
    return await fn();
  } catch (error) {
    logError(scope, error);
    throw new Error(humanizeError(error));
  }
}
